// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");

var greyDark3 = /* `hex */[
  5194459,
  "E7E7E7"
];

Css.$$global("h1", /* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontSize(Css.px(26)),
        /* :: */[
          Css.textTransform(/* uppercase */-415330030),
          /* :: */[
            Css.fontWeight(700),
            /* [] */0
          ]
        ]
      ]
    ]);

Css.$$global("h2", /* :: */[
      Css.color(/* `hex */[
            5194459,
            "F66297"
          ]),
      /* :: */[
        Css.fontSize(Css.px(22)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("h3", /* :: */[
      Css.color(/* `hex */[
            5194459,
            "F66297"
          ]),
      /* :: */[
        Css.fontSize(Css.px(20)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("h4", /* :: */[
      Css.color(/* `hex */[
            5194459,
            "FF328C"
          ]),
      /* :: */[
        Css.fontSize(Css.px(18)),
        /* :: */[
          Css.fontWeight(700),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("body", /* :: */[
      Css.color(Css.hex("1D2129")),
      /* :: */[
        Css.fontSize(Css.px(16)),
        /* :: */[
          Css.fontWeight(400),
          /* :: */[
            Css.lineHeight(1.5),
            /* [] */0
          ]
        ]
      ]
    ]);

Css.$$global("button", /* :: */[
      Css.cursor(/* pointer */-786317123),
      /* [] */0
    ]);

Css.$$global("div", /* :: */[
      Css.display(Css.flexBox),
      /* [] */0
    ]);

Css.$$global("a", /* :: */[
      Css.textDecoration(/* underline */131142924),
      /* :: */[
        Css.selector("&:hover", /* :: */[
              Css.textDecoration(/* none */-922086728),
              /* [] */0
            ]),
        /* :: */[
          Css.color(/* `hex */[
                5194459,
                "00C9C8"
              ]),
          /* [] */0
        ]
      ]
    ]);

Css.$$global("a:hover", /* :: */[
      Css.textDecoration(/* none */-922086728),
      /* [] */0
    ]);

var main = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.flexDirection(Css.row),
        /* :: */[
          Css.alignItems(Css.stretch),
          /* :: */[
            Css.justifyContent(Css.center),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    92.0
                  ]),
              /* :: */[
                Css.maxWidth(Css.px(500)),
                /* :: */[
                  Css.background(/* `hex */[
                        5194459,
                        "FCEBEC"
                      ]),
                  /* :: */[
                    Css.minHeight(Css.px(500)),
                    /* :: */[
                      Css.paddingBottom(Css.px(30)),
                      /* :: */[
                        Css.margin4(Css.px(0), Css.px(10), Css.px(30), Css.px(10)),
                        /* :: */[
                          Css.paddingLeft(Css.px(10)),
                          /* :: */[
                            Css.paddingRight(Css.px(10)),
                            /* [] */0
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.padding4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
        /* :: */[
          Css.textAlign(Css.center),
          /* :: */[
            Css.display(Css.flexBox),
            /* :: */[
              Css.flexDirection(Css.column),
              /* :: */[
                Css.alignItems(Css.center),
                /* :: */[
                  Css.background(Css.white),
                  /* :: */[
                    Css.width(/* `percent */[
                          -119887163,
                          100.0
                        ]),
                    /* :: */[
                      Css.borderBottomLeftRadius(Css.px(8)),
                      /* :: */[
                        Css.borderBottomRightRadius(Css.px(8)),
                        /* :: */[
                          Css.boxShadow(/* Some */[Css.px(1)], /* Some */[Css.px(1)], /* Some */[Css.px(3)], /* None */0, /* None */0, Css.rgba(224, 44, 123, 0.2)),
                          /* [] */0
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var buttonBasics_000 = Css.textAlign(Css.center);

var buttonBasics_001 = /* :: */[
  Css.whiteSpace(Css.nowrap),
  /* :: */[
    Css.borderRadius(Css.px(50)),
    /* :: */[
      Css.cursor(/* pointer */-786317123),
      /* :: */[
        Css.fontWeight(700),
        /* :: */[
          Css.alignItems(Css.center),
          /* :: */[
            Css.flexDirection(Css.row),
            /* :: */[
              Css.justifyContent(Css.center),
              /* [] */0
            ]
          ]
        ]
      ]
    ]
  ]
];

var buttonBasics = /* :: */[
  buttonBasics_000,
  buttonBasics_001
];

var greenButtonRaw_000 = Css.selector("&:hover", /* :: */[
      Css.color(greyDark3),
      /* [] */0
    ]);

var greenButtonRaw_001 = /* :: */[
  Css.margin4(Css.px(10), Css.px(0), Css.px(10), Css.px(0)),
  /* :: */[
    Css.fontSize(Css.px(20)),
    /* :: */[
      Css.minWidth(Css.px(170)),
      /* :: */[
        Css.height(Css.px(40)),
        /* :: */[
          Css.background(/* `linearGradient */[
                616379637,
                /* tuple */[
                  /* `deg */[
                    4995526,
                    76
                  ],
                  /* :: */[
                    /* tuple */[
                      5,
                      Css.hex("80e7e7")
                    ],
                    /* :: */[
                      /* tuple */[
                        93,
                        Css.hex("00a2a1")
                      ],
                      /* [] */0
                    ]
                  ]
                ]
              ]),
          /* :: */[
            Css.color(Css.white),
            /* :: */[
              Css.textTransform(Css.uppercase),
              /* :: */[
                Css.border(Css.px(1), /* solid */12956715, Css.hex("80E7E7")),
                buttonBasics
              ]
            ]
          ]
        ]
      ]
    ]
  ]
];

var greenButtonRaw = /* :: */[
  greenButtonRaw_000,
  greenButtonRaw_001
];

function greenButton() {
  return Css.style(greenButtonRaw);
}

function greenButtonDisabled() {
  return Css.style(/* :: */[
              Css.opacity(0.4),
              greenButtonRaw
            ]);
}

var greenSecondaryButtonRaw_000 = Css.selector("&:hover", /* :: */[
      Css.background(/* `hex */[
            5194459,
            "E2F2F2"
          ]),
      /* [] */0
    ]);

var greenSecondaryButtonRaw_001 = /* :: */[
  Css.minWidth(Css.px(135)),
  /* :: */[
    Css.fontSize(Css.px(16)),
    /* :: */[
      Css.height(Css.px(30)),
      /* :: */[
        Css.background(Css.white),
        /* :: */[
          Css.color(/* `hex */[
                5194459,
                "66B3B5"
              ]),
          /* :: */[
            Css.border(Css.px(1), /* solid */12956715, Css.hex("66B3B5")),
            buttonBasics
          ]
        ]
      ]
    ]
  ]
];

var greenSecondaryButtonRaw = /* :: */[
  greenSecondaryButtonRaw_000,
  greenSecondaryButtonRaw_001
];

var redButtonWideRaw_000 = Css.selector("&:hover", /* :: */[
      Css.background(/* `hex */[
            5194459,
            "FFEEEF"
          ]),
      /* [] */0
    ]);

var redButtonWideRaw_001 = /* :: */[
  Css.minWidth(Css.px(120)),
  /* :: */[
    Css.fontSize(Css.px(16)),
    /* :: */[
      Css.height(Css.px(20)),
      /* :: */[
        Css.background(Css.white),
        /* :: */[
          Css.color(Css.hex("FF328C")),
          /* :: */[
            Css.border(Css.px(1), /* solid */12956715, Css.hex("FF328C")),
            buttonBasics
          ]
        ]
      ]
    ]
  ]
];

var redButtonWideRaw = /* :: */[
  redButtonWideRaw_000,
  redButtonWideRaw_001
];

var redButtonWideDisabledRaw_000 = Css.color(Css.hex("FABCD2"));

var redButtonWideDisabledRaw = /* :: */[
  redButtonWideDisabledRaw_000,
  redButtonWideRaw
];

var redButtonNarrowRaw_000 = Css.width(Css.px(80));

var redButtonNarrowRaw = /* :: */[
  redButtonNarrowRaw_000,
  redButtonWideRaw
];

var redButtonNarrowDisabledRaw_000 = Css.color(Css.hex("FABCD2"));

var redButtonNarrowDisabledRaw = /* :: */[
  redButtonNarrowDisabledRaw_000,
  redButtonNarrowRaw
];

function simpleButton() {
  return Css.style(greenButtonRaw);
}

function simpleButtonReset() {
  return Css.style(/* :: */[
              Css.marginBottom(Css.px(10)),
              greenButtonRaw
            ]);
}

function simpleButtonWhiteSpaceBelow() {
  return Css.style(/* :: */[
              Css.marginBottom(Css.px(90)),
              greenButtonRaw
            ]);
}

function slimButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(10.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.maxWidth(Css.em(20.0)),
                  greenButtonRaw
                ]
              ]
            ]);
}

function verySlimButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.em(8.0)),
              /* :: */[
                Css.fontSize(Css.px(18)),
                /* :: */[
                  Css.maxWidth(Css.em(16.0)),
                  /* :: */[
                    Css.minHeight(Css.em(2.0)),
                    /* :: */[
                      Css.marginRight(Css.px(10)),
                      /* :: */[
                        Css.marginLeft(Css.px(10)),
                        greenButtonRaw
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var textColor = /* `hex */[
  5194459,
  "F66297"
];

var headColor = /* `hex */[
  5194459,
  "FF328C"
];

var pink1 = /* `hex */[
  5194459,
  "F43086"
];

var pink2 = /* `hex */[
  5194459,
  "F67AA6"
];

var pink3 = /* `hex */[
  5194459,
  "F67AA6"
];

var pink4 = /* `hex */[
  5194459,
  "F997C2"
];

var pink5 = /* `hex */[
  5194459,
  "FABCD2"
];

var pink6 = /* `hex */[
  5194459,
  "FFEEEF"
];

var blue1 = /* `hex */[
  5194459,
  "00A2A1"
];

var blue2 = /* `hex */[
  5194459,
  "05EDD6"
];

var blue3 = /* `hex */[
  5194459,
  "00CFCE"
];

var blue4 = /* `hex */[
  5194459,
  "80D0D0"
];

var blue5 = /* `hex */[
  5194459,
  "82F6EA"
];

var blue6 = /* `hex */[
  5194459,
  "80E7E7"
];

var greyDark1 = /* `hex */[
  5194459,
  "747474"
];

var greyDark2 = /* `hex */[
  5194459,
  "A4A4A4"
];

var greyLight1 = /* `hex */[
  5194459,
  "FAFAFA"
];

var greyLight2 = /* `hex */[
  5194459,
  "EFEFEF"
];

var greyLight3 = /* `hex */[
  5194459,
  "E6E6E6"
];

var standardFontSize = /* `px */[
  25096,
  16
];

var smallFontSize = /* `px */[
  25096,
  12
];

exports.textColor = textColor;
exports.headColor = headColor;
exports.pink1 = pink1;
exports.pink2 = pink2;
exports.pink3 = pink3;
exports.pink4 = pink4;
exports.pink5 = pink5;
exports.pink6 = pink6;
exports.blue1 = blue1;
exports.blue2 = blue2;
exports.blue3 = blue3;
exports.blue4 = blue4;
exports.blue5 = blue5;
exports.blue6 = blue6;
exports.greyDark1 = greyDark1;
exports.greyDark2 = greyDark2;
exports.greyDark3 = greyDark3;
exports.greyLight1 = greyLight1;
exports.greyLight2 = greyLight2;
exports.greyLight3 = greyLight3;
exports.standardFontSize = standardFontSize;
exports.smallFontSize = smallFontSize;
exports.main = main;
exports.contentBox = contentBox;
exports.buttonBasics = buttonBasics;
exports.greenButtonRaw = greenButtonRaw;
exports.greenButton = greenButton;
exports.greenButtonDisabled = greenButtonDisabled;
exports.greenSecondaryButtonRaw = greenSecondaryButtonRaw;
exports.redButtonWideRaw = redButtonWideRaw;
exports.redButtonWideDisabledRaw = redButtonWideDisabledRaw;
exports.redButtonNarrowRaw = redButtonNarrowRaw;
exports.redButtonNarrowDisabledRaw = redButtonNarrowDisabledRaw;
exports.simpleButton = simpleButton;
exports.simpleButtonReset = simpleButtonReset;
exports.simpleButtonWhiteSpaceBelow = simpleButtonWhiteSpaceBelow;
exports.slimButton = slimButton;
exports.verySlimButton = verySlimButton;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/theme.re
// module id = 6
// module chunks = 0